<div class="report row">
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 col-md-4 d-flex justify-content-start">
                <span class="">Client ID:</span>
            </div>
            <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ customer.customerId }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-3 d-flex justify-content-start">
                <span class="">Client:</span>
            </div>
            <div class="col-9 d-flex justify-content-start font-weight-bold">
                <span class="itemCreated">
                    {{ customer.customerName }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 col-md-4 d-flex justify-content-start">
                <span class="">Phone No.:</span>
            </div>
            <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ customer.customerPhone1 }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Interest Added:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold">
                <span class="itemCreated">
                    {{
                    itm.interestAdded | number
                    }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 col-md-4 d-flex justify-content-start">
                <span class="">Txn Date:</span>
            </div>
            <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.txnDate }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-5 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">txnTime:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.txnTime }}
                </span>
            </div>
        </div>
    </div>
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start ">
                <span class="">Balance:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.theBalance | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Principal Waived:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.principalWaived | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Principal Paid:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.principalPaid | number}}
                </span>
            </div>
        </div>
    </div>
    <div class="field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
                <span class="">Principal Involved:</span>
            </div>
            <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.principalInvolved | number}}
                </span>
            </div>
        </div>
    </div>
    <div class="field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">loan Interest Waived:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.loanInterestWaived | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field-5 col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">loan Interest Reversed:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.loanInterestReversed }}
                </span>
            </div>
        </div>
    </div>
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Loan Interest Paid:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.loanInterestPaid | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Loan Interest Involved:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.loanInterestInvolved | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Interest Waived:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.interestWaived | number }}
                </span>
            </div>
        </div>
    </div>
    <div class="field col-12 col-md-6 col-xl-4">
        <div class="row">
            <div class="col-5 d-flex justify-content-start">
                <span class="">Interest Paid:</span>
            </div>
            <div class="col-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
                <span class="itemCreated">
                    {{ itm.interestPaid | number }}
                </span>
            </div>
        </div>
    </div>
</div>